// Based on : https://github.com/bluzi/google-tasks-api/blob/master/lib/google-tasks-api.js

export default function (o) {
  o.load = function () {
    if (this.isLoaded()) { return Promise.resolve() }

    return new Promise(resolve => {
      let scr = document.createElement('script')
      scr.setAttribute('async', true)
      scr.setAttribute('defer', true)
      scr.setAttribute('src', 'https://apis.google.com/js/api.js')
      scr.onload = (ev) => { this.onLoaded(ev, resolve) }
      document.head.appendChild(scr)
    })
  }
  o.isLoaded = function () {
    return this.gapi && this.gapi.auth2 && typeof this.gapi.auth2.getAuthInstance === 'function'
  }
  o.onLoaded = function (ev, resolve0) {
    this.gapi = window.gapi
    let p = new Promise((resolve /* , reject */) => {
      this.gapi.load('client:auth2', resolve)
    })
    p.then(() => {
      // Return Promise-like goog.Thenable object
      let q = this.gapi.client.init({
        apiKey: this.API_KEY,
        clientId: this.CLIENT_ID,
        discoveryDocs: [ 'https://www.googleapis.com/discovery/v1/apis/tasks/v1/rest' ],
        scope: 'https://www.googleapis.com/auth/tasks'
      })
//      console.log('JK4', q, resolve0)
      q.then(() => {
        resolve0(1)
      })
    })
  }
  o.authorize = async function () {
    console.log('gapi.authorize() 0')
    let p = await this.load()
    console.log('gapi.authorize() 9', this.isLoaded(), p)
    return p
  }
  o.instance = function () {
    return this.gapi.auth2.getAuthInstance()
  }
  o.tasklists_list = function () {
    if (!this.gapi.client.tasks) {
      console.log('JK: no client.tasks')
      return new Promise()
    }
    console.log('JK: have tasks')
    return this.gapi.client.tasks.tasklists.list({
      'maxResults': 20
    })
  }
  o.makeRequest = async function (req) {
    await this.load()
    return new Promise((resolve, reject) => {
      req.execute(res => res.error ? reject(res.error) : resolve(res.result))
    })
  }
  o.listTaskLists = async function () {
    await this.load()
    return (await this.makeRequest(this.gapi.client.tasks.tasklists.list())).items
  }
  o.listTasks = async function (taskListId) {
    await this.load()
    let items = [], req = { tasklist: taskListId, maxResults: 100 }
    for (;;) {
      let r = await this.makeRequest(this.gapi.client.tasks.tasks.list(req))
      Array.prototype.push.apply(items, r.items)
      console.log('API lists nextToken', r.nextPageToken)
      if (!r.nextPageToken) {
        break
      }
      req.pageToken = r.nextPageToken
    }
    return items
  }
  o.updateTask = async function ({ taskListId, taskId, ...params }) {
    await this.load()
    console.log('API updateTasks', taskListId, taskId, params)
    return this.makeRequest(this.gapi.client.tasks.tasks.update({
      tasklist: taskListId,
      task: taskId,
      id: taskId,
      ...params
    }))
  }
  o.insertTask = async function ({ taskListId, ...params }) {
    await this.load()
    console.log('API insertTask', taskListId, params)
    return this.makeRequest(this.gapi.client.tasks.tasks.insert({
      tasklist: taskListId,
      ...params
    }))
  }
  o.deleteTask = async function ({ taskListId, taskId, ...params }) {
    await this.load()
    console.log('API deleteTask', taskListId, taskId, params)
    return this.makeRequest(this.gapi.client.tasks.tasks.delete({
      tasklist: taskListId,
      task: taskId,
      ...params
    }))
  }
  o.moveTask = async function ({ taskListId, taskId, ...params }) {
    await this.load()
    console.log('API moveTask', taskListId, taskId, params)
    return this.makeRequest(this.gapi.client.tasks.tasks.move({
      tasklist: taskListId,
      task: taskId,
      ...params
    }))
  }
  return o
}
